import { render, staticRenderFns } from "./parking-space.vue?vue&type=template&id=b5c00e42&scoped=true&"
import script from "./parking-space.vue?vue&type=script&lang=js&"
export * from "./parking-space.vue?vue&type=script&lang=js&"
import style0 from "./parking-space.vue?vue&type=style&index=0&id=b5c00e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c00e42",
  null
  
)

export default component.exports